export default __webpack_public_path__ + "static/media/FacebookLogo.a45f340f.svg";